export const VALID_EU_NUMBER_REGEX =
  /^\d+(?:\.\d+)*(?:,\d{1,3})?$|^\d+(?:,)?\d{1,3}$/;
export const VALID_IMPERIAL_NUMBER_REGEX = /^(\d+(,\d+)*(\.\d{1,3})?)$/;
